@if (universalService.allowUpload) {
  <div class="drag-n-drop-wrap" appDroppable [attr.droppable]="true">
    <img src="https://static.jiocloud.com/web2.0/common/images/drag-drop-logo.svg" alt="JioAICloud drag to upload icon" class="img-fluid upload" data-toggle="modal" data-target="#drag-to-shared-folder-modal">
    <div class="txt-content">
      @if (universalService.dragDropWithinApp) {
        <p>Drop files/folders to move instantly in : <br /><span class="NeueFolderFilled mr-1"></span>{{universalService.destinationFolder?.objectName}}</p>
      }
      @if (!universalService.dragDropWithinApp && !universalService.destinationFolder['objectKey'] && universalService.openFolderContent) {
        <p>Drop files/folders to upload instantly in : <br /><span class="NeueFolderFilled mr-1"></span>{{folderService.currentFolderName}}</p>
      }
      @if (!universalService.dragDropWithinApp && !universalService.destinationFolder['objectKey'] && !universalService.openFolderContent) {
        <p>Drop files/folders to upload instantly in : <br /><span class="NeueCloudFilled mr-1"></span>{{universalService.destinationFolder?.objectName}}</p>
      }
      @if (!universalService.dragDropWithinApp && universalService.destinationFolder['objectKey']) {
        <p>Drop files/folders to upload instantly in : <br /><span class="NeueFolderFilled mr-1"></span>{{universalService.destinationFolder?.objectName}}</p>
      }
    </div>
  </div>
}
@if (universalService.dragDropWithinApp && universalService.selectedNodes.length>0) {
  <div id="drag-move-snack">
    <!-- Snack Top -->
    <div class="snack-wrapper"  [ngClass]="[universalService.selectedNodes.length==1 ? 'snack-top-single' : 'snack-top-multiple']">
      <div class="row m-0 p-0">
        <div class="col-3 p-0">
          @if (universalService.selectedFile.format == 'PDF') {
            <span class="NeuePDFFilled align-top"></span>
          }
          @if (universalService.selectedFile.format == 'text' || universalService.format == 'HTML') {
            <span class="NeueTXTFilled align-top"></span>
          }
          @if (universalService.selectedFile.format == 'image') {
            <img class="imgBlock align-top"  loading="lazy" src="{{universalService.currentTab == 'PrivateFolder' && !universalService.selectedFile.imageTranscodeUrl.includes('ppftoken') ?universalService.selectedFile.imageTranscodeUrl+'&ppfToken='+this.ppfToken:universalService.selectedFile.imageTranscodeUrl}}" onerror="this.src='https://static.jiocloud.com/ng/images/no-img.jpg'">
          }
          @if (universalService.selectedFile.format == 'SpreadSheet' || universalService.selectedFile.format == 'Presentation' || universalService.selectedFile.format == 'MSOfficeDocument' || universalService.selectedFile.format == 'Document' || universalService.selectedFile.format == 'Word' || universalService.selectedFile.format == 'msword' ) {
            <img class="imgBlock align-top"  loading="lazy" src="{{universalService.selectedFile.MSOfficeImage}}">
          }
          @if (universalService.selectedFile.format == 'application') {
            <span class="NeueOtherFiles align-top"></span>
          }
          @if (universalService.selectedFile.format == 'audio') {
            <span class="NeueAudio align-top"></span>
          }
          @if (universalService.selectedFile.format == 'video') {
            <span class="NeuePlayFilled align-top"></span>
          }
          @if (universalService.selectedFile.format == 'Folder') {
            <span class="iso-folder" [ngClass]="[(universalService.selectedFile.shareType == 'R' && universalService.selectedFile.isShared) ? 'NeueSharedFolder' : 'NeueFolderFilled']"></span>
          }
          @if (universalService.selectedFile.format == 'audio' || universalService.selectedFile.format == 'video') {
            <img
              class="default-block" loading="lazy"
              src="{{universalService.currentTab == 'PrivateFolder' && !universalService.selectedFile.imageTranscodeUrl.includes('ppftoken') ?universalService.selectedFile.imageTranscodeUrl+'&ppfToken='+this.ppfToken:universalService.selectedFile.imageTranscodeUrl}}" onerror="this.style.display='none'">
          }
        </div>
        <div class="col-9 p-0 txt-align">{{universalService.selectedFile["objectDragName"]}}</div>
      </div>
    </div>
    <!--  -->
    @if (universalService.selectedNodes.length > 1) {
      <span class="counter">{{universalService.selectedNodes.length}}</span>
    }
  </div>
}

